'use client'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const Loader = styled.span`
  display: flex;
  margin: auto;
  border-radius: 50%;
  width: ${({ size }) => size || '2rem'};
  height: ${({ size }) => size || '2rem'};
  border: 0.25rem solid #ccc;
  border-top-color: ${({ fillColor }) =>
    fillColor ? `${fillColor}` : '#fb586c'};
  animation: ${spin} 500ms infinite linear;
`
